<template>
  <div>
    <ul class="ul-selectable-months disable-user-select margin-bottom-x1">
      <li
        v-for="(months, i) in availableSubscriptions"
        :key="i"
        @click="() => $emit('input', i)"
        :class="value === i ? 'selected' : ''"
      >
        <p>{{ `${months} ${__('månad')}${months > 1 ? __('er') : ''}` }}</p>
        <p v-if="currentProduct">
          {{
            `${Math.round(currentProduct.prices[i] / months)} ${__('KR/MÅN')}`
          }}
        </p>
        <p v-if="currentProduct" class="text-small margin-bottom-x1">
          {{ `${__('Totalt:')} ${currentProduct.prices[i]} ${__('kr')}` }}
        </p>
        <div @click="showDetailsID = showDetailsID === i ? -1 : i">
          <div
            :style="[
              {
                'max-height': showDetailsID === i ? '550px' : '0',
                transition: 'max-height 1s',
                overflow: 'hidden',
              },
            ]"
          >
            <p v-if="currentProduct" class="text-xs-small margin-bottom-x1">
              {{
                `${__('Bindningstiden är')} ${months} ${__(
                  'månader (total kostnad'
                )} ${currentProduct.prices[i]} ${__(
                  'kr), om du säger upp abonnemanget före bindningstidens utgång kommer ingen återbetalning av kvarvarande belopp att ske. Abonnemanget omvandlas automatiskt i slutet av bindningstiden till ett löpande månatligt abonnemang till den kostnad som vid var tid gäller för motsvarande paket (för närvarande'
                )} ${currentProduct.prices[0]} ${__(
                  'kr/mån), om du inte sagt upp det dessförinnan.'
                )}`
              }}
            </p>
          </div>
          <icon-chevron-down class="text-white" :rotate="showDetailsID === i" />
        </div>
        <button
          class="button button-snd mobile"
          @click="
            () => {
              $emit('input', i)
              next()
            }
          "
        >
          {{ __('Välj') }}
        </button>
      </li>
    </ul>
    <slot />
  </div>
</template>
<script>
import updateQuery from '@/mixins/updateQuery'

export default {
  props: ['value', 'next', 'preselected', 'productId'],
  data () {
    return {
      showDetailsID: -1,
    }
  },
  mixins: [updateQuery],
  components: {
    IconChevronDown: () => import('@/components/icons/IconChevronDown.vue'),
  },
  mounted () {},
  computed: {
    currentProduct () {
      return this.$store.getters.currentProduct
    },
    availableSubscriptions () {
      return this.$store.getters.availableSubscriptions
    },
  },
}
</script>
<style lang="less">
@import '../style/variables.less';
.ul-selectable-months {
  display: flex;
  list-style: none;
  flex-direction: column;
  align-items: center;
  max-width: 600px;
  > li {
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    background: @color-grey;
    padding: 1.4em;
    padding-top: 2.5em;
    margin: 1em;
    max-width: 300px;
    > :first-child {
      color: white;
    }
    > :nth-child(2) {
      font-family: Oswald;
      font-size: 1.5em;
      font-weight: 500;
      color: @color-orange;
    }
    button {
      margin-bottom: 0;
      margin-top: 1em;
    }
  }
}
@media (min-width: @width-device-md) {
  .ul-selectable-months {
    flex-direction: row;
    flex-wrap: wrap;
    align-items: flex-start;
    > li {
      margin: 0.5em;
      border: 2px solid transparent;
      width: calc(50% - 1em);
    }
    > li.selected {
      border-color: @color-orange;
    }
  }
}
</style>
